import { Injectable } from '@angular/core';

declare var ___MobileAgent___: any;
declare var tmx_profiling_complete: any;

@Injectable()
export class ThreatMetrixService {

    private profilePromise : Promise<string>;
    private initialized: boolean;

    constructor() {
        this.initialized = false;
    }

    Init(): void {

        this.profilePromise = new Promise((resolve, reject) => {
            tmx_profiling_complete.SetSubscriber(resolve);
            ___MobileAgent___.Profile();
        });

        this.initialized = true;
    }

    Profile(): Promise<string> {

        if (this.initialized == false) {
            this.Init();
        }

        return this.profilePromise;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/ThreatMetrix/threatmetrix.ts